export default {
  common: {
    loading: 'Loading',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    back: 'Back',
    copy: 'Copy',
    delete: 'Delete',
    copySuccess: 'Copied',
    editSuccess: 'Edited successfully',
    deleteSuccess: 'Deleted successfully',
    modifySuccess: 'Updated successfully',
    cannotBeEmpty: 'Cannot be empty',
    noContent: 'No content available',
    noData: 'No relevant data',
    noMoreData: 'No more data',
    iKnow: 'Got it',
    selectService: 'Choose provider',
    sendSuccess: 'Sent',
  },
  billHome: {
    recharge: 'Top-up & Bills',
    coupon: 'Coupons',
    rechargeNow: 'Top Up Now',
    cost: 'Mobile Credit',
    flow: 'Data',
    rechargeNotice: 'Top-up Info',
    rechargeCost: 'Mobile Credit Top-up',
    rechargeFlow: 'Data Top-up',
    rechargeAmount: 'Top-up Amount',
    rechargePackage: 'Top-up Package',
    discount: 'Discount Applied',
    confirmTxt: 'Confirm',
    confirmTxt1: 'Understood',
    actualPayment: 'To Pay',
    selectCoupon: 'Choose Coupon',
    useRule: 'Usage Rules',
    availableCoupon: 'Available Coupons',
    unavailableCoupon: 'Unavailable Coupons',
    noAvailableCoupon: 'No available coupons',
    selectPhone: 'Select Phone Number',
    pleaseInputPhone: 'Enter phone',
    couponCount: 'Coupons available',
    pleaseInputCorrectPhone: 'Please enter the correct phone number',
    pleaseSelectPackage: 'Please select a recharge package',
  },
  accountManage: {
    title: 'Account Management',
    edit: 'Edit',
    deleteConfirm: 'Confirm Deletion',
  },
  rechargeDetail: {
    title: 'Payment Details',
    continuePay: 'Continue to Pay',
  },
  feesExpense: {
    title: 'Payment Records',
    recharge: 'Mobile',
    electricity: 'Electricity',
    internet: 'Internet',
    water: 'Water',
    photo: 'Photo',
    complete: 'Done',
    manage: 'Manage',
    allSelect: 'Select All',
    selected: 'Selected',
    deleteConfirm: 'Delete',
    deleteRecord: 'record(s)?',
    noDataAction: 'No data to manage',
    pleaseSelect: 'Please select record(s) to delete',
    feesNotice: 'Payment Notice',
  },
  formCom: {
    upload: 'Tap to Upload',
    saveAccount: 'Save or update existing account',
    createOrder: 'Create Order',
    rechargeIng: 'Topping Up',
    rechargeNow: 'Top Up Now',
    serviceProvider: 'Provider',
    billImage: 'Bill Image',
    returnSelect: 'Back to Re-select',
    electricity: 'Electricity Bill',
    internet: 'Internet Bill',
    water: 'Water Bill',
    photo: 'Photo Payment',
    life: 'Utility Bills',
    uploadFail: 'Upload failed. Please try again.',
    pleaseFill: 'Please complete all fields',
    submitSuccess: 'Submitted. Awaiting payment',
  },
  langPop: {
    selectLang: 'Choose Language',
  },
  loginPop: {
    loginOrRegister: 'Log in or register with Kuaizi',
    confirmLogout: 'Are you sure you want to log out?',
    toLogin: 'Log In',
    logoutSuccess: 'Logged out successfully',
  },
  newMe: {
    myOrder: 'My Orders',
    coupon: 'Coupons',
    accountManage: 'Account Management',
    orderCount: 'Orders in progress',
    couponCount: 'Coupons',
    account: 'Account',
    logout: 'Log Out',
  },
  coupons: {
    all: 'All',
    coupon: 'Coupon',
    historyCoupon: 'Used/Expired',
    use: 'Use Now',
    validityPeriod: 'Valid Until',
    useRule: 'Usage Rules',
    used: 'Used',
    expired: 'Expired',
  },
  accountSeting: {
    title: 'Settings',
    personalInfo: 'Personal Info',
    modifyPayPassword: 'Change Payment Password',
    modifyLoginPassword: 'Change Login Password',
    phone: 'Phone Number',
    code: 'Verification Code',
    loginPassword: 'Login Password',
    confirmModify: 'Confirm',
    noCode: 'Didn’t receive the code?',
    passwordPlaceholder: '8–16 characters, letters & numbers',
    inputCorrectPhone: 'Enter a valid phone number',
    afterGetCode: 'Retry after',
    getCode: 'Get Code',
    input6DigitPassword: 'Enter 6-digit password',
    twoInputPasswordNotConsistent: 'Passwords do not match',
    placeholderCode: 'Enter verification code',
    confirmPassword: 'Confirm Password',
    password: 'Password',
    submit: 'Submit',
    avatar: 'Avatar',
    userName: 'Username',
    nickName: 'Nickname',
    modifyPhone: 'Change Phone Number',
    nickNamePlaceholder: 'Be unique',
    sex: 'Gender',
    male: 'Male',
    female: 'Female',
    email: 'Email',
    emailPlaceholder: 'Add email to recover password',
    pleaseCompletePersonalData: 'Please complete your profile to access more features',
    bindNewPhone: 'Bind New Phone Number',
    oldPhone: 'Old Phone',
    completeVerification: 'Complete Verification',
    changePayPasswordTitle: 'Change Payment Password',
    changePasswordTitle: 'Change Password',
    oldPhoneTitle: 'Verify Old Phone Number',
    editInfoTitle: 'Edit Profile',
    areaCode: 'Area Code',
  },
}
